/**
 * Created with IntelliJ IDEA.
 * User: Odeds
 * Date: 4/02/16
 * Time: 5:52 PM
 */
define(function (require) {
    "use strict";
    var version = "0.1";
    var LE = require("app");

    var Logger = require("logger");
    var logger = Logger.getLogger("LEManager");
    var Checkbox = require("ui/checkbox/Checkbox");

    var template = require("manager-components/apiListSelection/templates/apiListSelection.tmpl");


    var APIListSelection = {};
    LE.module('LEManager', function (LEManager, LE, Backbone, Marionette, $, _) {
        APIListSelection = Marionette.ItemView.extend({
            className: "api-list-selection",
            template: template,
            events: {
                "click .api-group .api-title": "_toggleGroup"
            },
            ui: {
                apiList: ".api-list",
                apiGroups: ".api-group",
                apiCBs: ".apiCB"
            },

            /****************************************************************** VIEW INTERFACE ***************************************************
             *
             */
            initialize: function(options) {
                LEManager.logger.debug("enter function", "APIListSelection:initialize");
                if (!options.el) {
                    logger.error("el for APIListSelection is mandatory");
                    logger.graph({name:"manager:APIListSelection:elMissing"});
                    return null;
                }
                // create the static internal model and apply the state passed in through options.value
                var apiFullListName = LEManager.getModuleDataManager().getEntities().API_FULL_LIST;
                this.model= LEManager.getModuleDataManager().getData(apiFullListName).factory(options.value);
            },
            onRender:  function(){
                LEManager.logger.debug("enter function", "APIListSelection:onRender");
                this.cbs= {};
                var apiCBs= this.ui.apiCBs;
                apiCBs.each(_.bind(function (index, el) {
                    this._renderAPIParentCB(el);
                }, this));
                this.ui.apiGroups.first().addClass("opened");
            },
            onBeforeClose: function(){
                _.each(this.cbs, function(cbArr){
                    if (_.isArray(cbArr)) {
                        _.each(cbArr, function(cb) {
                            if (_.isFunction(cb.close)) {
                                cb.close();
                            }
                        });
                    }
                });
                delete this.cbs;
            },

            /****************************************************************** COMPONENT INTERFACE **********************************************
             *
             */
            version: function(){
                return version;
            },

            /****************************************************************** SPECIFIC INTERFACE ***********************************************
             *
             */
            setAdvanced: function(value){
                 this.ui.apiList.toggleClass("advanced", value);
            },
            getPrivileges: function(){
                return this.model.getState();
            },

            /****************************************************************** PRIVATE **********************************************************
             *
             */
            _getAPICheckBoxState: function(apiName){
                return this.model.getApiState(apiName);
            },
            _toggleGroup: function(event){
                LEManager.logger.debug("enter function", "APIListSelection:_toggleGroup");
                var $element= $(event.currentTarget);
                var isOpened= $element.closest(".api-group").hasClass("opened");

                this.ui.apiGroups.removeClass("opened");
                $element.closest(".api-group").toggleClass("opened", !isOpened);
            },
            _renderAPIParentCB: function (element){
                LEManager.logger.debug("enter function", "APIListSelection:_renderAPIParentCB");
                //render parent api cb
                var api= $(element).data("api");
                var apiName= LE.translator.translate("LEManager.manager.dataSources.Api_Keys.data."+ api);

                var groupEl= $(element).closest(".api-group");
                var checkState= this._getAPICheckBoxState(api);
                var apiCB = new Checkbox({
                    mode: Checkbox.MODES.TRISTATE,
                    checked: checkState,
                    label: apiName,
                    permutation: Checkbox.PERMUTATION.A,
                    el: element
                });
                apiCB.render();
                this.listenTo(apiCB, Checkbox.TRIGGERING.CHANGE, _.bind(function(state){
                    this.model.updateAPI(api, state === Checkbox.STATES.CHECKED);
                    //update child cbs
                    $(this.cbs[api]).each(_.bind(function (index, cb) {
                        cb.setCheckedState(state);
                    }, this));
                    this.trigger("change", api, state);
                },this));

                //render api child key cbs
                this._renderAPIChildKeyCBs(api, element, apiCB, groupEl);
            },
            _renderAPIChildKeyCBs: function(api, element, apiCB, groupEl) {
                LEManager.logger.debug("enter function", "APIListSelection:_renderAPIChildKeyCBs");
                this.cbs[api]= [];
                var keyCBs= $(element).closest(".api-key").find(".keyCB");
                keyCBs.each(_.bind(function (index, element) {
                    var key= $(element).data("key");

                    var keyName= key && key.replace(/[.-\s]/g, "_");
                    keyName= LE.translator.translate("LEManager.manager.dataSources.Api_Keys.data.keys."+ keyName);

                    var isChecked= this.model.hasKey(key);

                    var keyCB = new Checkbox({
                        checked: isChecked,
                        label: keyName,
                        permutation: Checkbox.PERMUTATION.A,
                        el: element
                    });
                    keyCB.render();
                    this.cbs[api].push(keyCB);
                    this.listenTo(keyCB, Checkbox.TRIGGERING.CHANGE, _.bind(function(state){
                        this.model.updateKey(key, state);
                        //update parent api cb state
                        var checkState= this._getAPICheckBoxState(api);
                        apiCB.setCheckedState(checkState);
                        this.trigger("change", key, state);
                    },this));

                }, this));
            }

        });
        return APIListSelection;
    });
    return APIListSelection;
});
